<template>
  <div>
    <h1><router-link to="https://zpl.io/blmD8gG">Fan - Live Stream</router-link></h1>
    <p>
        When the live stream is online (streaming), the content should have a video + live chat widget
        like in <router-link to="https://zpl.io/blmDPPD">Artist Live Stream</router-link> design.
    </p>
    <Player v-if="contentId !== null" v-bind:content-id="contentId" :autoplay="true"></Player>
    <p>
        This tests the frontend - backend - dacast integration and requires the live event to be created
        on the backend that corresponds to the correct live channel on DaCast. For regular testing of
        video player that hardcodes an existing video file, go to
        <router-link to="/video/">Demo Video Player</router-link> page.
    </p>
    <p>
      Go back to <router-link to="/">Hello World</router-link> page.
    </p>

  </div>
</template>

<style scoped>
</style>

<script>
import Player from '@/components/widgets/Player'

export default {
  components: {
    Player
  },
  data () {
    return {
      contentId: null
    }
  },
  computed: {

  },
  methods: {

  },
  created () {
    this.$store
      .dispatch('attendLiveEvent', {id: this.$route.params.id})
      .then(resp => {
        this.contentId = resp.dacast_content_id
      })
  }
}
</script>

<style scoped>
p {
  margin: 1em auto;
  padding: 0 5em 0 5em;
  max-width: 80em;
  text-align: left;
}
.center {
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/fan/LiveStream.vue